<template>
    <table class="table table-bordered table-hover">
        <tbody>
        <tr>
            <th style="width: 200px;">Mac address</th>
            <td>{{device.mac_addr}}</td>
        </tr>
        <tr>
            <th>Fitting number</th>
            <td>{{device.fitting_number}}</td>
        </tr>
        <tr>
            <th>Level</th>
            <td>{{device.level}}</td>
        </tr>
        <tr>
            <th>Location</th>
            <td>{{device.location}}</td>
        </tr>
        <tr>
            <th>Manufacture date</th>
            <td v-if="device.manufacture_date === undefined || device.manufacture_date === null">N/A</td>
            <td v-else>{{tools.formatDateWithFullYear(new Date(device.manufacture_date * 1000))}}</td>
        </tr>
        <tr>
            <th>Installation date</th>
            <td v-if="device.installation_date === undefined || device.installation_date === null">N/A</td>
            <td v-else>{{tools.formatDateWithFullYear(new Date(device.installation_date * 1000))}}</td>
        </tr>
        <tr>
            <th>Activation date</th>
            <td v-if="device.activation_date === undefined || device.activation_date === null">N/A</td>
            <td v-else>{{tools.formatDateWithFullYear(new Date(device.activation_date * 1000))}}</td>
        </tr>
        <tr>
            <th>Warranty Available</th>
            <td v-if="device.warranty === undefined || device.warranty === null">N/A</td>
            <td v-else>{{device.warranty}} days</td>
        </tr>
        <tr>
            <th>Warranty Expires</th>
            <td v-if="device.activation_date === undefined || device.activation_date === null">N/A</td>
            <td v-else>{{tools.humanizedTimeSpan(sourceWarranty, new Date())}}</td>
        </tr>
        <tr>
            <th>Warranty Expire date</th>
            <td v-if="device.activation_date === undefined || device.activation_date === null">N/A</td>
            <td v-else>{{tools.formatDateWithFullYear(sourceWarranty)}}</td>
        </tr>
        <tr>
            <th>Firmware no.</th>
            <td>{{device.firmware_no}}</td>
        </tr>
        <tr>
            <th>Fitting type</th>
            <td>{{device.fitting_type_id?device.fitting_type.name:'N/A'}}</td>
        </tr>
        <tr>
            <th>Device model</th>
            <td>{{device.device_model_id?device.device_model.name:'N/A'}}</td>
        </tr>
        <tr>
            <th>Last operation</th>
            <td>
                <div v-if="device.mac_addr">
                    <DeviceAuditLog v-bind:macAddress="device.mac_addr"/>
                </div>
                <div v-else>
                    Not available
                </div>
            </td>
        </tr>
        <slot name="append"/>
        </tbody>
    </table>
</template>


<script>
  import Tools from '@/app-model/tools';
  import DeviceAuditLog from "@/components/audit/DeviceAuditLog";
  export default {
    components: {DeviceAuditLog},
    props: {
      source: Object
    },
    data () {
      return {
        inner: {
          id: undefined,
          gateway_id: undefined,
          device_model_id: undefined,
          fitting_type_id: undefined,
          firmware_no: undefined,
          type: undefined,
          ip_addr: undefined,
          mac_addr: undefined,
          ble_version: undefined,
          python_ver: undefined,
          device_type: undefined,
          building_id: undefined,
          last_building_id: undefined,
          level: undefined,
          location: undefined,
          fitting_number: undefined,
          description: undefined,
          last_comm: undefined,
          device_model: {
            id: undefined,
            name: undefined,
            description: undefined,
          },
          files: [],
          fitting_type: {
            id: undefined,
            name: undefined,
            description: undefined,
          },
          status: undefined,
          manufacture_date: undefined,
          installation_date: undefined,
          activation_date: undefined,
          warranty: undefined,
          warranty_transfer_from: undefined,
          warranty_claim_at: undefined,
        }
      }
    },
    computed: {
      tools: function () {
        return new Tools;
      },
      sourceWarranty() {
        let warrantyExpiry = new Date(this.device.activation_date * 1000);
        warrantyExpiry.setDate(warrantyExpiry.getDate() + this.device.warranty)
        return warrantyExpiry;
      },
      device() {
        this.inner = this.source;
        return this.inner;
      }
    },
    mounted () {
    },
  }
</script>